import SvgFeatureAnalytics from "@public/svg/features/analytics.svg"
import SvgFeatureBranding from "@public/svg/features/branding.svg"
import SvgFeatureContactless from "@public/svg/features/contactless.svg"
import SvgFeatureCustomProperties from "@public/svg/features/custom-properties.svg"
import SvgFeatureDeliveryZones from "@public/svg/features/delivery-zones.svg"
import SvgFeatureDevices from "@public/svg/features/devices.svg"
import SvgFeatureDisplayOptions from "@public/svg/features/display-options.svg"
import SvgFeatureDomain from "@public/svg/features/domain.svg"
import SvgFeatureFastLoading from "@public/svg/features/fast-loading.svg"
import SvgFeatureFeedback from "@public/svg/features/feedback.svg"
import SvgFeatureInstall from "@public/svg/features/install.svg"
import SvgFeatureIntegrations from "@public/svg/features/integrations.svg"
import SvgFeatureMultipleLanguages from "@public/svg/features/multiple-languages.svg"
import SvgFeatureNotifications from "@public/svg/features/notifications.svg"
import SvgFeaturePaymentGateway from "@public/svg/features/payment-gateway.svg"
import SvgFeaturePromos from "@public/svg/features/promos.svg"
import SvgFeatureSearch from "@public/svg/features/search.svg"
import SvgFeatureSpecialCategory from "@public/svg/features/special-category.svg"
import SvgFeatureVideos from "@public/svg/features/videos.svg"

export const EmenuFeatures = [
  {
    title: "branding",
    description: "branding_text",
    icon: SvgFeatureBranding,
  },
  {
    title: "display",
    description: "display_text",
    icon: SvgFeatureDisplayOptions,
  },
  {
    title: "search",
    description: "search_text",
    icon: SvgFeatureSearch,
  },
  {
    title: "properties",
    description: "properties_text",
    icon: SvgFeatureCustomProperties,
  },
  {
    title: "specials",
    description: "specials_text",
    icon: SvgFeatureSpecialCategory,
  },
  {
    title: "media",
    description: "media_text",
    icon: SvgFeatureVideos,
  },
  {
    title: "promos",
    description: "promos_text",
    icon: SvgFeaturePromos,
  },
  {
    title: "languages",
    description: "languages_text",
    icon: SvgFeatureMultipleLanguages,
  },
  {
    title: "feedback",
    description: "feedback_text",
    icon: SvgFeatureFeedback,
  },
  {
    title: "delivery",
    description: "delivery_text",
    icon: SvgFeatureDeliveryZones,
  },
  {
    title: "analytics",
    description: "analytics_text",
    icon: SvgFeatureAnalytics,
  },
  {
    title: "payment_gateways",
    description: "payment_gateways_text",
    icon: SvgFeaturePaymentGateway,
  },
  {
    title: "integrations",
    description: "integrations_text",
    icon: SvgFeatureIntegrations,
  },
  {
    title: "custom_domain",
    description: "custom_domain_text",
    icon: SvgFeatureDomain,
  },
  {
    title: "notifications",
    description: "notifications_text",
    icon: SvgFeatureNotifications,
  },
]

export const HomeEmenuFeatures = [
  {
    icon: SvgFeatureVideos,
    description: "media",
  },
  {
    icon: SvgFeatureFastLoading,
    description: "fast",
  },
  {
    icon: SvgFeatureBranding,
    description: "branding",
  },
  {
    icon: SvgFeatureDevices,
    description: "devices",
  },
  {
    icon: SvgFeatureContactless,
    description: "contactless",
  },
  {
    icon: SvgFeaturePromos,
    description: "promos",
  },
  {
    icon: SvgFeatureInstall,
    description: "install",
  },
]
